// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__Bv67D","email":"ContactForm_email__QqoKt","fullName":"ContactForm_fullName__Sk2RF","send":"ContactForm_send__UWiYc"};